// AdBanner.jsx (React Web Production Version)
import React, { useEffect, useRef } from "react";

export default function AdBanner() {
  const adLoaded = useRef(false); // Tracks if the ad was already pushed

  useEffect(() => {
    // Only push the ad if it hasn't been loaded in this specific component instance yet
    if (!adLoaded.current) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        adLoaded.current = true; // Mark as loaded
      } catch (e) {
        console.error("AdSense integration error or ad blocker active:", e);
      }
    }
  }, []);

  return (
    <div 
      className="adsense-display-container" 
      style={{ 
        overflow: "hidden", 
        textAlign: "center", 
        margin: "10px 0",
        minHeight: "100px", 
        width: "100%", // ✅ FIX: Prevents "availableWidth=0" error
        display: "block"
      }}
    >
      <ins
        className="adsbygoogle"
        style={{ display: "block", width: "100%" }} // ✅ FIX: Ensures Google can read the width
        data-ad-client="ca-pub-3034885339654373"
        data-ad-slot="7037980395"
        data-ad-format="auto"
        data-full-width-responsive="true" // ✅ Recommended for standard display ads
      ></ins>
    </div>
  );
}